import React from 'react';

import { useNavigate } from 'react-router-dom';

import { Button } from '../../atoms/button';
import { Heading } from '../../atoms/heading';
import { Text } from '../../atoms/text';
import pathes from 'src/constants/pathes';
import { useTranslation } from 'react-i18next';

export interface ErrorPageProps {
  error: string;
}

export const ErrorPage: React.FC<ErrorPageProps> = ({ children, error }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  return (
    <div className="t-error-page">
      <div className="t-error-page__container">
        <Heading level="h3">{error}</Heading>
        <hr />
        <Text type="p"> {children}</Text>
        <Button modifiers="login" onClick={() => navigate(pathes.HOME_PAGE)}>
          {t('signup.homepage')}
        </Button>
      </div>
    </div>
  );
};
